<div class="changepassword__content-wrapper flex-row-start">

  <mat-card appearance="outlined" class="flex-fill">
    <mat-card-title>
      <h1>Change password</h1>
    </mat-card-title>
    <mat-card-content>

      <p>
        We'll email a password reset link to <strong>{{ user?.email }}</strong>.
        Resetting your password will sign you out of other sessions.
      </p>

      <p *ngIf="sent" class="changepassword__message">
        We sent a reset link to {{ user?.email }}. Didn't get it? Click <strong>Resend</strong> or check your spam folder.
      </p>

      <div class="changepassword__button-wrapper">
        <button mat-flat-button color="accent" type="button" (click)="sendPasswordReset()" [disabled]="sending">
          {{ sending ? 'SENDING…' : (sent ? 'RESEND' : 'SEND RESET LINK') }}
        </button>
      </div>


      <div *ngIf="error" class="changepassword__error-wrapper">
        <mat-error>{{ error }}</mat-error>
      </div>

    </mat-card-content>
  </mat-card>
</div>
